import { useBlocker } from "react-router-dom";
import { useEffect } from "react";
import { openPopupModal, PopupModalName } from "../components/elements/popupModalProvider/popupModalSlice";
import { useAppDispatch } from "../app/hooks";

export function useUnsavedChangesWarning(hasUnsavedChanges: boolean) {
    const blocker = useBlocker(hasUnsavedChanges);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (blocker.state !== "blocked") return;

        dispatch(openPopupModal({
            name: PopupModalName.UNSAVED_CHANGES,
            popupModalProps: {
                handleContinue: () => {
                    blocker.proceed();
                },
                handleCancel: () => {
                    blocker.reset();
                }
            }
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blocker]);
}
